import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import scrollReveal from './plugins/scrollReveal'
import './assets/css/bootstrap.css';
import './assets/css/main.css';

createApp(App)
  .use(store)
  .use(router)
  .use(scrollReveal, { router })
  .mount('#app')

document.getElementById('app-boot-splash')?.remove()
